import React from 'react';
import { Box, Text, Grid, GridItem } from '@chakra-ui/react';
import dayjs from 'dayjs';

const StatementHeader = ({ merchant, period }) => {
  if (!merchant) return null;

  return (
    <Box bg="white" p="2rem" borderRadius="8px" mb="2rem" boxShadow="md">
      <Text fontSize="20px" fontFamily="bold" color="brand.header" mb="2rem">
        Merchant Information
      </Text>
      <Grid templateColumns="repeat(2, 1fr)" gap="1.5rem">
        <GridItem>
          <Text fontSize="14px" color="#808080" mb="0.5rem">
            Name
          </Text>
          <Text fontSize="16px" fontFamily="medium" color="brand.header">
            {merchant.first_name} {merchant.last_name}
          </Text>
        </GridItem>
        <GridItem>
          <Text fontSize="14px" color="#808080" mb="0.5rem">
            Email
          </Text>
          <Text fontSize="16px" fontFamily="medium" color="brand.header">
            {merchant.email}
          </Text>
        </GridItem>
        <GridItem>
          <Text fontSize="14px" color="#808080" mb="0.5rem">
            Company Name
          </Text>
          <Text fontSize="16px" fontFamily="medium" color="brand.header">
            {merchant.company_name}
          </Text>
        </GridItem>
        <GridItem>
          <Text fontSize="14px" color="#808080" mb="0.5rem">
            Phone Number
          </Text>
          <Text fontSize="16px" fontFamily="medium" color="brand.header">
            {merchant.phone_number}
          </Text>
        </GridItem>
        <GridItem colSpan={2}>
          <Text fontSize="14px" color="#808080" mb="0.5rem">
            Company Address
          </Text>
          <Text fontSize="16px" fontFamily="medium" color="brand.header">
            {merchant.company_address}
          </Text>
        </GridItem>
      </Grid>

      {period && period.start_date && period.end_date && (
        <Box mt="2rem" pt="2rem" borderTop="1px solid #E5E5E5">
          <Text fontSize="16px" fontFamily="bold" color="brand.header">
            Statement Period:{' '}
            <Text as="span" fontFamily="medium" color="#444444">
              {dayjs(period.start_date).format('MMM D, YYYY')} -{' '}
              {dayjs(period.end_date).format('MMM D, YYYY')}
            </Text>
          </Text>
        </Box>
      )}
    </Box>
  );
};

export { StatementHeader };
